/* eslint-disable jsx-a11y/no-static-element-interactions */

import * as React from 'react';
import classNames from 'classnames';

import DateRangePicker from './DateRangePicker';

// eslint-disable-next-line no-unused-vars
import { DateRange, DefinedRange } from '../types';

export interface DateRangePickerWrapperProps {
    open: boolean;
    toggle: () => void;
    initialDateRange?: DateRange;
    definedRanges?: DefinedRange[];
    minDate?: Date | string;
    maxDate?: Date | string;
    onChange: (dateRange: DateRange) => void;
    closeOnClickOutside?: boolean;
    wrapperClassName?: string;
}

const DateRangePickerWrapper: React.FunctionComponent<
    DateRangePickerWrapperProps
> = (props: DateRangePickerWrapperProps) => {
    const { closeOnClickOutside, wrapperClassName, toggle, open } = props;

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleToggle = () => {
        if (closeOnClickOutside === false) {
            return;
        }

        toggle();
    };

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const handleKeyPress = (event: any) =>
        event?.key === 'Escape' && handleToggle();

    const wrapperClasses = classNames('dateRangePicker', wrapperClassName);

    return (
        <div className="dateRangePickerContainer">
            {open && (
                <div
                    className="dateRangeBackdrop"
                    onKeyPress={handleKeyPress}
                    onClick={handleToggle}
                />
            )}

            <div className={wrapperClasses}>
                <DateRangePicker {...props} />
            </div>
        </div>
    );
};

export default DateRangePickerWrapper;
